import angular from 'angular';
import Model from './model';
import AnalyticsServ from '../services/analytics';

function SourceFactory(Model, AnalyticsServ) {
	return class SourceModel extends Model {
		constructor(data = {}) {
			super(data);
			this.setApi("/case/:caseId/source/:sourceId", {
				caseId: '@caseId',
				sourceId: '@id'
			}, {
				'create': {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
					},
					success: [
						data => this.setData(data),
						data => AnalyticsServ.added('Source', {
							'Source Format': data.format
						})
					]
				},
				'linkBoxFile': {
					url: '/case/:caseId/source/link/boxFile',
					method: 'PUT',
					success: [
						data => this.setData(data),
						data => AnalyticsServ.added('Source', {
							'Source Format': data.format
						})
					]
				},
				'linkDropboxFile': {
					url: '/case/:caseId/source/link/dropboxFile',
					method: 'PUT',
					success: [
						data => this.setData(data),
						data => AnalyticsServ.added('Source', {
							'Source Format': data.format
						})
					]
				},
				'linkClioFile': {
					url: '/case/:caseId/source/link/clioFile',
					method: 'PUT',
					success: [
						data => this.setData(data),
						data => AnalyticsServ.added('Source', {
							'Source Format': data.format
						})
					]
				},
				'update': {
					method: 'PUT',
					success: [
						data => this.setData(data),
						data => AnalyticsServ.updated('Source')
					]
				},
				'delete': {
					method: 'DELETE',
					success: [
						() => this.setData(), () => AnalyticsServ.removed('Source')
					]
				},
			});
		}
	}
}
SourceFactory.$inject = ['Model', 'AnalyticsServ'];

export default angular.module('models.source', [Model, AnalyticsServ])
	.factory('Source', SourceFactory)
	.name;



// WEBPACK FOOTER //
// ./project/models/source.js